import { EmployeeApiClient } from '@/clients/employeeApiClient';
import { Employee } from '@/types/employee';

export class EmployeeService {
  private apiClient: EmployeeApiClient;

  constructor() {
    this.apiClient = new EmployeeApiClient();
  }

  async listEmployees(): Promise<Employee[]> {
    return this.apiClient.listEmployees();
  }

  async getMyEmployee(): Promise<Employee | null> {
    return this.apiClient.getByUserId();
  }

  async createEmployee(data: { name?: string; iban?: string; userId?: string }): Promise<Employee> {
    return this.apiClient.createEmployee(data);
  }

  async updateEmployee(employeeId: string, data: { name?: string | null; iban?: string | null }): Promise<Employee> {
    return this.apiClient.updateEmployee(employeeId, data);
  }

  async mergeEmployee(sourceId: string, targetId: string): Promise<Employee> {
    return this.apiClient.mergeEmployee(sourceId, targetId);
  }

  async deleteEmployee(employeeId: string): Promise<void> {
    return this.apiClient.deleteEmployee(employeeId);
  }
}
